import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';
import { RebateAgreementDTO } from './types';

interface DuplicateRebateAgreementRequest {
  sourceAgreementId: string;
  name: string;
  startDate: string;
  endDate: string;
}

const useDuplicateRebateAgreement = () => {
  const queryClient = useQueryClient();

  return useMutationApi<DuplicateRebateAgreementRequest, RebateAgreementDTO>({
    endpoint: 'rebates/agreements/duplicate',
    method: 'POST',
    options: {
      onSuccess: () => {
        // Invalidate rebate agreements queries to refresh the data
        queryClient.invalidateQueries({ queryKey: ['rebateAgreements'] });
      },
    },
    successMessage: 'Rebate agreement duplicated successfully',
  });
};

export default useDuplicateRebateAgreement;
